import emailConfigCreate from './Create'
import emailConfigEdit from './Edit'
import emailConfigList from './List'

const emailConfigResource = {
  create: emailConfigCreate,
  edit: emailConfigEdit,
  list: emailConfigList,
}

export default emailConfigResource
